// Image optimization utilities

// Add loading event listeners to images
export const optimizeImageLoading = () => {
  // Add intersection observer for lazy loading fallback
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.classList.remove('lazy');
            observer.unobserve(img);
          }
        }
      });
    });

    // Observe all lazy images
    document.querySelectorAll('img[loading="lazy"]').forEach(img => {
      imageObserver.observe(img);
    });
  }

  // Add load event listeners for smooth transitions
  document.querySelectorAll('img').forEach(img => {
    if (img.complete) {
      img.classList.add('loaded');
    } else {
      img.addEventListener('load', () => {
        img.classList.add('loaded');
      });
      
      img.addEventListener('error', () => {
        img.classList.add('error');
        // Optionally set a fallback image
        // img.src = '/Pictures/placeholder.jpg';
      });
    }
  });
};

// Preload critical images
export const preloadCriticalImages = (imageUrls) => {
  imageUrls.forEach(url => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = url;
    document.head.appendChild(link);
  });
};

// Create responsive image srcset
export const createResponsiveImage = (basePath, sizes = [400, 800, 1200]) => {
  const extension = basePath.split('.').pop();
  const baseName = basePath.replace(`.${extension}`, '');
  
  return sizes.map(size => `${baseName}_${size}w.${extension} ${size}w`).join(', ');
};

// Image compression quality settings
export const getOptimalImageFormat = () => {
  // Check for WebP support
  const canvas = document.createElement('canvas');
  canvas.width = 1;
  canvas.height = 1;
  
  return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0 ? 'webp' : 'jpg';
};

// Lazy loading with fade-in effect
export const addFadeInEffect = () => {
  const style = document.createElement('style');
  style.textContent = `
    img[loading="lazy"] {
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
    }
    
    img[loading="lazy"].loaded {
      opacity: 1;
    }
    
    img[loading="lazy"].error {
      opacity: 0.5;
      filter: grayscale(100%);
    }
  `;
  document.head.appendChild(style);
};